"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeadlineStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

var _headerTitles = require("../header-titles/header-titles.styled");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  ", " {\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SectionHeadlineStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, _headerTitles.DescriptionStyled);
exports.SectionHeadlineStyled = SectionHeadlineStyled;